import { stringifyQuery, type QueryObject } from './query.js';

export interface BuildUrlOptions {
  base?: string;
  path?: string;
  query?: QueryObject;
  hash?: string;
}

export function joinPath(...segments: string[]): string {
  const filtered = segments.filter((s) => s !== undefined && s !== null && s !== '');
  if (filtered.length === 0) return '';
  let out = filtered[0] as string;
  for (let i = 1; i < filtered.length; i++) {
    const seg = filtered[i] as string;
    if (out.endsWith('/') && seg.startsWith('/')) out = out + seg.slice(1);
    else if (!out.endsWith('/') && !seg.startsWith('/')) out = out + '/' + seg;
    else out = out + seg;
  }
  return out;
}

export function buildUrl({ base = '', path = '', query, hash }: BuildUrlOptions): string {
  let url = joinPath(base, path);
  if (query) {
    const qs = stringifyQuery(query);
    if (qs) url += (url.includes('?') ? '&' : '?') + qs;
  }
  if (hash) url += hash.startsWith('#') ? hash : '#' + hash;
  return url;
}
